<template>
  <div class="inquiry-Management-modular">
    <div class="header-menu-bar-modular">
      <div class="menu-bar">
        <div
          class="menu-bar-item"
          v-for="(item, index) in menuBar"
          :key="index"
        >
          <span class="top-bar-title" @click="toPersonCenter(index)">{{
            currLanguage == 3 ? item.eng_title : item.title
          }}</span>
          <img
            class="top-bar-icon"
            v-if="index < menuBar.length - 1"
            src="../assets/productDetail/top-bar-icon.png"
            alt=""
          />
        </div>
      </div>
    </div>
    <div class="product-management-modular">
      <div class="product-info-modular">
        <div class="product-info-item">
          <div class="product-img-item">
            <img class="product-img" :src="productInfoData.cover" alt="" />
          </div>
          <div class="product-info-detail">
            <div class="product-info-title">
              {{
                currLanguage == 3
                  ? productInfoData.eng_title
                  : productInfoData.title
              }}
            </div>
            <div class="product-info-price">
              <div class="present-price">
                {{ exchange_rate_symbol
                }}{{
                  curr_product_has_discount == 0
                    ? showProductPrice
                    : showProductDiscountPrice
                }}
              </div>
              <div class="original-price" v-if="curr_product_has_discount == 1">
                {{ exchange_rate_symbol }}{{ showProductPrice }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="inquiry-management-modular">
      <div class="title">{{ pageTextArr[3] }}</div>
      <el-row :gutter="20">
        <el-col :span="8" :xs="24">
          <div class="user-info-item">
            <div class="user-info-item-header">
              <span class="must-icon">*</span>
              <span class="user-info-item-title">{{ pageTextArr[4] }}</span>
            </div>
            <div class="user-info-item-input-modular">
              <el-input
                class="item-input"
                v-model="userInfo.userName"
              ></el-input>
            </div>
          </div>
        </el-col>
        <el-col :span="8" :xs="24">
          <div class="user-info-item">
            <div class="user-info-item-header">
              <span class="must-icon">*</span>
              <span class="user-info-item-title">{{ pageTextArr[5] }}</span>
            </div>
            <div class="user-info-item-input-modular">
              <el-input class="item-input" v-model="userInfo.email"></el-input>
            </div>
          </div>
        </el-col>
        <el-col :span="8" :xs="24">
          <div class="user-info-item">
            <div class="user-info-item-header">
              <span class="user-info-item-title">{{ pageTextArr[6] }}</span>
            </div>
            <div class="user-info-item-input-modular">
              <el-input class="item-input" v-model="userInfo.mobile"></el-input>
            </div>
          </div>
        </el-col>
      </el-row>
      <div class="commont-mpdular">
        <div class="user-info-item">
          <div class="user-info-item-header">
            <span class="must-icon">*</span>
            <span class="user-info-item-title">{{ pageTextArr[7] }}</span>
          </div>
          <div class="user-info-item-input-modular">
            <el-input
              type="textarea"
              rows="10"
              class="item-input"
              v-model="userInfo.commont"
              maxlength="200"
              show-word-limit
            ></el-input>
          </div>
        </div>
      </div>
      <div class="upload-modular">
        <div class="title">{{ pageTextArr[8] }}</div>
        <!-- <img style="width: 122px;height: 122px;" :src="item.img" alt="" v-for="(item, index) in uploadImgData"> -->
        <div class="upload-item">
          <div>
            <!-- <img
              class="upload-img-item"
              :src="item"
              alt=""
              v-for="(item, index) in uploadImgData"
            />-->
          </div> 
          <!-- :show-file-list="false" -->
          <el-upload
            class="avatar-uploader"
            :action="uploadUrl"
            :headers="headerData"
            :before-upload="beforeFileUpload"
            :on-success="uploadImgSeccess"
            list-type="picture-card"
            :file-list="fileList"
          >
            <img v-if="dialogImageUrl" :src="dialogImageUrl" class="avatar" />
            <!-- <i v-else class="el-icon-plus avatar-uploader-icon"></i> -->
            <img
              src="../assets/productDetail/upload.png"
              alt=""
              srcset=""
              style="width: 122px; height: 122px"
            />
            <div slot="file" slot-scope="{ file }">
              <img
                class="el-upload-list__item-thumbnail"
                :src="file.url"
                alt=""
              />
              <span class="el-upload-list__item-actions">
                <span
                  class="el-upload-list__item-delete"
                  @click="handleRemove(file)"
                >{{pageTextArr[17]}}
                  <!-- <i class="el-icon-delete"></i> -->
                </span>
              </span>
            </div>
          </el-upload>
        </div>
        <div class="submit-modular">
          <el-button class="submit-btn" @click="sunmitEnquiry()">{{
            pageTextArr[9]
          }}</el-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      currLanguage: localStorage.getItem("curLanguageType"), //当前语言
      exchange_rate_symbol: localStorage.getItem("currencySymbol"),
      showProductPrice: "", //商品原价
      showProductDiscountPrice: "", //商品折扣价
      curr_product_has_discount: 0, //0-没有优惠，1-有优惠
      nasku_numberme: "",
      productId: "", //商品id
      uploadImgData: [], //上传的图片
      // 上传
      uploadUrl:
        localStorage.getItem("genericBaseUrl") + "/Home/Common/uploadimage",
      headerData: {}, //上传图片的header参数
      menuBar: [
        { title: "首页", eng_title: "Home" },
        { title: "产品", eng_title: "Product" },
        { title: "产品询价", eng_title: "Product inquiry" },
      ],
      userInfo: {
        userName: "",
        email: "",
        mobile: "",
        commont: "",
      },
      pageTextArr: [
        "首页",
        "产品",
        "产品询价",
        "询价",
        "全名",
        "邮箱",
        "电话",
        "内容",
        "请上传JPG/GIF/PNG文件。图片大小不能超过2MB。",
        "提交",
        "上传文件只能是JPG格式!",
        "上传xlsx表格文件且不能超过 5MB!",
        "请填写全名",
        "请填写邮箱",
        "请填写内容",
        "成功",
        "失败",
        "删除"
      ],
      productInfoData: {}, //产品数据
      fileList: [],
      dialogImageUrl: "",
      uploading: "",
    };
  },
  methods: {
    /**
     * 上传loading
     */
    uploadLoading() {
      let that = this;
      that.uploading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
    },

    /**
     * 上传完成之后
     * @param {*} res
     * @param {*} file
     */
    uploadImgSeccess(res, file,fileList) {
      let that = this;
      that.uploading.close();
      if (res.ret == 1) {
        that.fileList = fileList
        that.uploadImgData.push(res.data.file_url);
        console.log(that.fileList)
        console.log(that.uploadImgData)
      } else {
        that.$message({ title: "警告", message: res.msg, type: "error" });
      }
    },

    /**
     * 上传文件前判断
     * @param {*} file
     */
    beforeFileUpload(file) {
      // console.log("FILE", file);
      this.uploadLoading();
      const isJPG = file.type === "image/jpeg" || "image/jpg" || "image/png";
      const isLt2M = file.size / 1024 / 1024 < 5;

      if (!isJPG) {
        this.$message.error(this.pageTextArr[10]);
        this.fileList = [];
      }
      if (!isLt2M) {
        this.$message.error(this.pageTextArr[11]);
        this.fileList = [];
      }
      return isJPG && isLt2M;
    },

    handleRemove(file) {
     
      let url = file.response.data.file_url
      let index = this.uploadImgData.findIndex(item=>{
        return item === url
      })
      this.uploadImgData.splice(index,1)
      this.fileList.splice(index,1)
    },
    /**
     * 跳转个人中心
     */
    toPersonCenter(index) {
      let that = this;
      if (index == 0) {
        this.$router.push({
          path: "/",
        });
      } else {
        this.$router.push({
          path: "/productDetail",
          query: { product_id: that.productId },
        });
      }
    },

    /**
     * 产品详情
     */
    getProductDetail() {
      let that = this;
      let data = {
        product_id: that.productId, //产品ID
        exchange_rate: localStorage.getItem("currencyRate"), //汇率值
      };
      this.$http.getProductDetail(
        data,
        (res) => {
          if (res.ret == 1) {
            //商品原价
            that.showProductPrice = res.data.price;
            //商品折扣价
            that.showProductDiscountPrice = res.data.discount_price;
            // 是否有优惠
            that.curr_product_has_discount = res.data.has_discount;
            // 商品信息
            that.productInfoData = res.data;
            if (
              that.productInfoData &&
              this.currLanguage != 1 &&
              this.currLanguage != 3
            ) {
              that.languageTranslateByArrs(that.productInfoData, 2);
            }
            // 获取价格
            that.getDefaultSkuPrice(res.data.typeid, res.data.keydata);
          } else {
            this.$message.error(res.msg);
          }
        },
        (res) => {
          // this.$message.error(res.msg);
        }
      );
    },

    /**
     * 获取默认的规格
     */
    getDefaultSkuPrice(typeid, data) {
      let that = this;
      let specification = [];
      data.forEach((v, i) => {
        specification.push([v.id]);
        if (v.values.length > 0) {
          v.values.forEach((v2, i2) => {
            if (i2 == 0 && v2.specification_key_id == v.id) {
              specification[i].push(v2.id);
              v2.flag = true;
            } else {
              v2.flag = false;
            }
            // 设施状态
          });
        }
      });
      // sku
      that.nasku_numberme = specification;
      // 商品价格
      that.getDetailPriceBySku(typeid, specification);
    },

    /**
     * 商品价格
     * @param {*} typeid
     * @param {*} productSku
     */
    getDetailPriceBySku(typeid, productSku) {
      let that = this;
      let data = {
        product_id: that.productId, //产品ID
        typeid: typeid, //分类ID
        specification: productSku, //商品规格
        exchange_rate: localStorage.getItem("currencyRate"), //汇率值
        exchange_rate_symbol: localStorage.getItem("currencySymbol"), //汇率值符号
      };
      this.$http.getDetailPriceBySku(
        data,
        (res) => {
          if (res.ret == 1) {
            //商品原价
            that.showProductPrice = res.data.price;
            //商品折扣价
            that.showProductDiscountPrice = res.data.discount_price;
            // Sku-number
            that.currProductSkuNumber = res.data.sku_number;
            // 是否有优惠
            that.curr_product_has_discount = res.data.has_discount;
            //
            that.time_discount_id = res.data.time_discount_id;
          } else {
            this.$message.error(res.msg);
          }
        },
        (res) => {
          // this.$message.error(res.msg);
        }
      );
    },

    /**
     * 提交
     */
    sunmitEnquiry() {
      let that = this;
      if (that.userInfo.userName == "") {
        this.$message.warning(
          that.currLanguage == 3
            ? "Please fill in your full name"
            : this.pageTextArr[12]
        );
      } else if (that.userInfo.email == "") {
        this.$message.warning(
          that.currLanguage == 3
            ? "Please fill in the mailboxe"
            : this.pageTextArr[13]
        );
      } else if (that.userInfo.commont == "") {
        this.$message.warning(
          that.currLanguage == 3
            ? "Please fill in the contents"
            : this.pageTextArr[14]
        );
      } else {
        that.submitProductConsult();
      }
    },

    /**
     * 询价
     */
    submitProductConsult() {
      let that = this;
      let data = {
        name: that.userInfo.userName,
        email: that.userInfo.email,
        mobile: that.userInfo.mobile,
        content: that.userInfo.commont,
        pics: that.uploadImgData.join(","),
        product_id: that.productId,
        nasku_numberme: that.nasku_numberme,
        type: 1, //1为询价2为疑问
      };
      this.$http.submitProductConsult(
        data,
        (res) => {
          if (res.ret == 1) {
            this.$message.success(this.pageTextArr[15]);
            setTimeout(() => {
              this.$router.push({
                path: "/productDetail",
                query: { product_id: that.productId },
              });
            }, 1000);
          } else {
            this.$message.error(res.msg);
          }
        },
        (res) => {
          // this.$message.error(res.msg);
        }
      );
    },

    translateByArr(arr, callback, errCallBack) {
      let that = this;
      let data = {
        text: arr, //带翻译数组
        from: localStorage.getItem("oldLanguageCode"), //源语言
        to: localStorage.getItem("curLanguageCode"), //目标语言
      };
      if (data.from == data.to) {
        return;
      }
      this.$http.translateByArr(data, callback, errCallBack);
    },

    languageTranslateByArrs(arr, type) {
      let that = this;
      let newpagetextArr = [];
      if (type == 1) {
        that.translateByArr(arr, (res) => {
          res.data.forEach((item, index) => {
            newpagetextArr.push(item.translation);
          });
          that.pageTextArr = newpagetextArr;
          that.menuBar[0].title = that.pageTextArr[0];
          that.menuBar[1].title = that.pageTextArr[1];
          that.menuBar[2].title = that.pageTextArr[2];
        });
      } else {
        let pro = [];
        pro.push(arr.title);
        that.translateByArr(pro, (res) => {
          that.productInfoData.title = res.data[0].translation;
        });
      }
    },
  },
  mounted() {
    let that = this;
    that.headerData = {
      accesstoken: localStorage.getItem("token"),
    };
    // 产品详情ID
    that.productId = that.$route.query.product_id;
    // 产品详情
    that.getProductDetail();
    that.languageTranslateByArrs(that.pageTextArr, 1);
  },
};
</script>


// WEBPACK FOOTER //
// src/view/inquiryManagement.vue